export const RTL_LANGUAGES: Record<string, boolean> = {
  ar: true, // Arabic
  he: true, // Hebrew
  fa: true, // Persian
  ur: true, // Urdu
  ps: true, // Pashto
  sd: true, // Sindhi
  dv: true, // Dhivehi
  ku: true, // Kurdish
  ug: true, // Uyghur
};
